import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class GnbBookmark extends Vue {
    @Prop({ type: Array }) bookMarkItems!: gnb.BookMarkItem[];
}